import React from "react";

/** One tab in a tab band, matching the app-wide neutral tab + accent-underline pattern. */
export default function TabBandButton({
  active,
  onClick,
  label,
  count,
  className = "",
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  /** Shown as a muted badge after the label, e.g. how many items the tab holds. */
  count?: number;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      className={`-mb-px inline-flex cursor-pointer items-center gap-2 rounded-t-md border-b-2 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/30 ${
        active
          ? "relative z-10 border-accent text-text"
          : "border-transparent text-text-dim hover:bg-muted-surface/50 hover:text-text"
      } ${className}`}
    >
      {label}
      {count !== undefined && (
        <span className="rounded-full bg-muted-surface px-1.5 py-0.5 text-xs font-medium tabular-nums text-text-mid">
          {count}
        </span>
      )}
    </button>
  );
}
